export default function Contact() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
            保持联系
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            联系我们
          </h2>
          <p className="mt-3 text-sm text-foreground-500">
            向日葵视频期待你的反馈与建议，以下方式均可与我们取得联系
          </p>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-5">
            <div className="p-6 rounded-xl bg-background-100 border border-background-200/60">
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100/80 text-primary-600 mx-auto">
                <i className="ri-mail-line text-xl"></i>
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-900">投稿合作</h3>
              <p className="mt-2 text-sm text-foreground-500">
                欢迎优质内容创作者加入，获取更多曝光与收益
              </p>
              <a
                href="#contact"
                onClick={(e) => e.preventDefault()}
                className="mt-4 inline-block text-sm text-primary-600 font-medium hover:text-primary-700 transition-colors cursor-pointer"
              >
                了解详情 <i className="ri-arrow-right-line ml-1"></i>
              </a>
            </div>
            <div className="p-6 rounded-xl bg-background-100 border border-background-200/60">
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100/80 text-secondary-600 mx-auto">
                <i className="ri-question-answer-line text-xl"></i>
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-900">问题反馈</h3>
              <p className="mt-2 text-sm text-foreground-500">
                播放问题、资源报错、功能建议，24小时内响应处理
              </p>
              <a
                href="#contact"
                onClick={(e) => e.preventDefault()}
                className="mt-4 inline-block text-sm text-secondary-600 font-medium hover:text-secondary-700 transition-colors cursor-pointer"
              >
                提交反馈 <i className="ri-arrow-right-line ml-1"></i>
              </a>
            </div>
            <div className="p-6 rounded-xl bg-background-100 border border-background-200/60">
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100/80 text-accent-600 mx-auto">
                <i className="ri-shake-hands-line text-xl"></i>
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-900">商务洽谈</h3>
              <p className="mt-2 text-sm text-foreground-500">
                广告投放、品牌合作、资源置换等商务合作接洽
              </p>
              <a
                href="#contact"
                onClick={(e) => e.preventDefault()}
                className="mt-4 inline-block text-sm text-accent-600 font-medium hover:text-accent-700 transition-colors cursor-pointer"
              >
                商务合作 <i className="ri-arrow-right-line ml-1"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}